// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__00Mxs","shimmer":"skeleton_shimmer__hVz_b"};